import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Menu } from "antd";
import {
    UserOutlined,
    CrownOutlined,
    SettingOutlined,
    HeartOutlined,
} from "@ant-design/icons";

function getItem(label, key, icon, children, type) {
    return {
        key,
        icon,
        children,
        label,
        type,
    };
}

const items = [
    getItem("Profile", "profile", <UserOutlined />),
    getItem("High Scores", "scores", <CrownOutlined />, [
        getItem("Taiko Mode", "enso"),
        getItem("AI Battle Mode", "ai"),
    ]),
    getItem("Favorites", "favorites", <HeartOutlined />),
    getItem("Mods", "mods", <SettingOutlined />),
];

const rootSubmenuKeys = ["sub1", "sub2", "sub4"];

const MainMenu = () => {
    const navigate = useNavigate();
    const [openKeys, setOpenKeys] = React.useState([]);
    const [selectedKeys, setSelectedKeys] = React.useState([]);

    const onOpenChange = (keys) => {
        const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);

        if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    };

    function handleClick(e) {
        let slug = e.key;
        if (e.keyPath && e.keyPath.length > 1) {
            slug = `${e.keyPath[1]}/${slug}`;
        }

        // set selected key
        setSelectedKeys(e.keyPath);

        navigate(`/${slug}`, { replace: true });
    }

    useEffect(() => {
        // set active state for menu based on path name
        let path = window.location.pathname;
        let pathParts = path.split("/");

        let slug = pathParts[1];

        if (pathParts[1] === "") {
            slug = "profile";
        }

        if (pathParts.length > 2) {
            slug = `${pathParts[1]}/${pathParts[2]}`;
        }
        setSelectedKeys([slug]);
    }, []);

    return (
        <Menu
            mode="inline"
            openKeys={openKeys}
            selectedKeys={selectedKeys}
            onOpenChange={onOpenChange}
            onClick={handleClick}
            disabled={false}
            style={{
                width: `100%`,
                marginTop: `-4px`,
            }}
            items={items}
            theme="dark"
        />
    );
};

export default MainMenu;
